import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { ApolloClient, createHttpLink, InMemoryCache, ApolloProvider } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';

const httpLink = createHttpLink({
  uri: `${window._env.REACT_APP_SERVER_HOST}/query`,
});

const getCustomAuthOrToken = (headers, token) => {
  // use custom-set authorization header if one is provided
  if (headers?.authorization) {
    return headers?.authorization;
  }

  const parsedToken = JSON.parse(token);
  return token && parsedToken ? parsedToken : '';
};

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: getCustomAuthOrToken(headers, token),
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      MapOption: {
        keyFields: false,
      },
    },
  }),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
